<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="模块名" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['mockName', validatorRules.mockName]" placeholder="请输入模块名"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="模块编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['mockCode', validatorRules.mockCode]" placeholder="请输入模块编号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="组装数据的DTO类名" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['mockDto', validatorRules.mockDto]" placeholder="请输入组装数据的DTO类名"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="生产数据查询接口" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['mockUrl', validatorRules.mockUrl]" placeholder="请输入生产数据查询接口"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="生产数据查询接口类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['mockUrlType', validatorRules.mockUrlType]" :trigger-change="true" dictCode="mock_url_type" placeholder="请选择使用状态"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="使用状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['useStatus', validatorRules.useStatus]" :trigger-change="true" dictCode="yes_or_no" placeholder="请选择使用状态"/>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"

  export default {
    name: 'SysApiMockForm',
    components: {
      JFormContainer,
      JDictSelectTag,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          mockName: {
            rules: [
              { required: true, message: '请输入模块名!'},
            ]
          },
          mockCode: {
            rules: [
              { required: true, message: '请输入模块编号!'},
              { validator: (rule, value, callback) => validateDuplicateValue('sys_api_mock', 'mock_code', value, this.model.id, callback)},
            ]
          },
          mockDto: {
            rules: [
              { required: true, message: '请输入组装数据的DTO类名!'},
            ]
          },
          mockUrl: {
            rules: [
              { required: true, message: '请输入生产数据查询接口!'},
            ]
          },
          mockUrlType: {
            rules: [
              { required: true, message: '请输入生产数据查询接口类型!'},
            ]
          },
          useStatus: {
            rules: [
              { required: true, message: '请输入使用状态!'},
            ]
          },
        },
        url: {
          add: "/sys/sysapimock/add",
          edit: "/sys/sysapimock/edit",
          queryById: "/sys/sysapimock/query/by/id"
        },
        bigdataId:null,
        mockDataType:null,
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add (bigdataId,mockDataType) {
        this.bigdataId = bigdataId;
        this.mockDataType = mockDataType;
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'mockName','mockCode','mockDto','mockUrl','useStatus','mockUrlType'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            if(!this.model.id){
              formData.bigdataId = this.bigdataId;
            }
            formData.mockDataType = this.mockDataType;
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'mockName','mockCode','mockDto','mockUrl','useStatus','mockUrlType'))
      },
    }
  }
</script>